import { FileWarningIcon, DownloadIcon } from "lucide-react";

import Message from "../../../../../i18n/Message";
import backend from "../../../../../backend/backend";

import "./BinaryFileMessage.scss";

const BinaryFileMessage = ({ path, workspaceId, projectUid }) => {
  const downloadUrl = backend.getProjectFileDownloadUrl(workspaceId, projectUid, path);
  const filename = path ? path.split("/").pop() : "file";

  const handleDownload = () => {
    // Create a temporary link to trigger download
    const link = document.createElement("a");
    link.href = downloadUrl;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div className="binary_file_message">
      <div className="message_content">
        <FileWarningIcon size={48} color="#9ca3af" />
        <p className="message_text">
          <Message
            id="builder_binary_file_message"
            defaultMessage="This file type cannot be displayed"
          />
        </p>
        <button className="download_button" onClick={handleDownload}>
          <DownloadIcon size={16} />
          <Message id="builder_download_file" defaultMessage="Download file" />
        </button>
      </div>
    </div>
  );
};

export default BinaryFileMessage;
